define(
  'app/views/mobile_only_buy_button_view',['app/setup', 'app/lib/ismobile','app/views/modal_view'],
  function(takhfifan, deviceDetect) {

  takhfifan.MobileOnlyBuyButtonView = Backbone.View.extend({

    events: {
      'click': 'showOptions'
    },

    initialize: function(options) {
      //init modal
      $('.modal-overlay').css('background', 'rgba(74, 74, 74, 0.5)');
      this.modalContainer = $('.mobile-only-deal-modal');
      takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
        this.modalContainer.hide();
      }, this);

      this.productId = options.productId;
      // this.loadGroupedOptionsView();
      var _this = this;
      if(this.$el.attr('disabled') === 'disabled'){
        takhfifan.eventHub.on('timeover:' + this.productId, function() {
          _this.disable();
          _this.setAsDeactive();
        }, this);
        
        takhfifan.eventHub.on('buyButton:soldOut', function() {
          _this.disable();
          _this.setAsDeactive();
        }, this);
      }
      else{
        takhfifan.eventHub.on('buyButton:enable', function() {
          _this.enableButton();
        }, this);
        
        this.setAsActive();
      }
    },
    
    enableButton: function() {
      this.setAsActive();
      this.enable();
    },

    showOptions: function(event) {
      event.preventDefault();
      var isSmartPhone = window.isMobile.apple.device || window.isMobile.android.device,
        appProductUrl = window.isMobile.apple.device? 'com.takhfifan.takhfifanapp://?widget=1&productId='+ this.productId : 'takhfifan://product/'+ this.productId;

      if(!isSmartPhone){
        this.showModal();
      }else{
        setTimeout(function () { window.location = "http://takhfifan.com/mobile"; }, 2000);
        window.location = appProductUrl;
      }
      return false;
    },

    showModal: function () {
      var modalTemplate = _.template($('#mobile-only-deal-modal').html());
      takhfifan.eventHub.trigger('modal:showModalWithContent',
        {
          triggerElement: this.$el,
          elementToOperateContent: modalTemplate(),
          fadeTimeIn:400,
          elementToOperate:this.modalContainer
        });
    },

    setAsActive: function() {
      this.$('.btn-text').empty().append('<span class="mobile-icon"></span>' + i18n.t('buy_with_cell_phone'));
    },
    
    setAsDeactive: function() {
      this.$('.btn-text').empty().append('<span class="mobile-icon">' + + i18n.t('deal_sold_out'));
    },

    disable: function() {
      this.undelegateEvents();
      this.$el.attr('disabled', true);
    },

    enable: function() {
      this.delegateEvents();
      this.$el.attr('disabled', false);
    }

  });

});

